import request from '../index';
import axios from 'axios';
export const getPlatformToken = (name, secret) =>
  axios({
    url: 'https://stream.livingscriptures.com/api/auth/token',
    method: 'POST',
    params: { name, secret },
  });
export const getDeviceCode = (name, token) =>
  request({
    url: 'devices',
    method: 'POST',
    params: {
      name,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const checkActivation = (token) =>
  request({
    url: `devices/${token}`,
    method: 'GET',
  });
